import { render, staticRenderFns } from "./DetailBox.vue?vue&type=template&id=94b535d8"
import script from "./DetailBox.vue?vue&type=script&lang=js"
export * from "./DetailBox.vue?vue&type=script&lang=js"
import style0 from "./DetailBox.vue?vue&type=style&index=0&id=94b535d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports